import useSWR from "swr";
import PaymentMethodService from "services/PaymentMethodService";

/**
 * Hook to fetch all payment methods from the API.
 * ALWAYS returns ONLY the array of payment methods.
 */
const usePaymentMethodsSwr = () => {
    const { data, error, isLoading } = useSWR(
        "paymentMethods_v2",
        async () => {
            const response = await PaymentMethodService.getAll();

            if (!response) return [];
            if (Array.isArray(response)) return response;
            if (Array.isArray(response?.data)) return response.data;

            return [];
        },
        { revalidateOnFocus: false }
    );

    return {
        paymentMethods: data || [],
        isLoading,
        isError: !!error,
    };
};

export default usePaymentMethodsSwr;
